import FrowningFace from "@/assets/icons/sentiment-negative.svg";
import NeutralFace from "@/assets/icons/sentiment-neutral.svg";
import HappyFace from "@/assets/icons/sentiment-positive.svg";
import VeryNegative from "@/assets/icons/sentiment-very-negative.svg";
import VeryPositive from "@/assets/icons/sentiment-very-positive.svg";
import { SENTIMENT as _SENTIMENT } from "@/constants";

export const SENTIMENT = {
  very_positive: {
    value: _SENTIMENT.VERY_POSITIVE,
    label: L.MENTIONS_SENTIMENT_TONE_VERY_POSITIVE,
    pluralLabel: L.MENTIONS_SENTIMENT_TONE_VERY_POSITIVE_PLURAL,
    icon: VeryPositive,
  },
  positive: {
    value: _SENTIMENT.POSITIVE,
    label: L.MENTIONS_SENTIMENT_TONE_POSITIVE,
    pluralLabel: L.CUSTOMERS_SENTIMENT_GRAPH_POSITIVE,
    icon: HappyFace,
  },
  neutral: {
    value: _SENTIMENT.NEUTRAL,
    label: L.MENTIONS_SENTIMENT_TONE_NEUTRAL,
    pluralLabel: L.CUSTOMERS_SENTIMENT_GRAPH_NEUTRAL,
    icon: NeutralFace,
  },
  negative: {
    value: _SENTIMENT.NEGATIVE,
    label: L.MENTIONS_SENTIMENT_TONE_NEGATIVE,
    pluralLabel: L.CUSTOMERS_SENTIMENT_GRAPH_NEGATIVE,
    icon: FrowningFace,
  },
  very_negative: {
    value: _SENTIMENT.VERY_NEGATIVE,
    label: L.MENTIONS_SENTIMENT_TONE_VERY_NEGATIVE,
    pluralLabel: L.MENTIONS_SENTIMENT_TONE_VERY_NEGATIVE_PLURAL,
    icon: VeryNegative,
  },
};

export const SENTIMENT_OPTIONS = [
  SENTIMENT.very_positive,
  SENTIMENT.positive,
  SENTIMENT.neutral,
  SENTIMENT.negative,
  SENTIMENT.very_negative,
];
